import { Model } from '@vuex-orm/core'

export default class Project extends Model {
  static entity = 'projects'

  static primaryKey = 'id'

  static fields () {
    return {
      id: this.attr(null),
      projectName: this.string(''),
      projectDescription: this.string(null).nullable(),
      projectOwnerId: this.attr(null),
      users: this.attr([]),
      projectChatId: this.attr(null),
      projectLabels: this.attr([]),
      projectLabelsAttributes: this.attr([]),
      userIds: this.attr([]),
      isArchived: this.boolean(false),
      userNotificationId: this.attr(null)
    }
  }

  static permitAttributes = [
    'projectName',
    'projectDescription',
    'projectOwnerId',
    'projectLabelsAttributes',
    'userIds'
  ]

  static skeleton() {
    return Object.fromEntries(
      Object.entries(this.fields())
      .map(([_, object]) => [_, object.value])
      .filter(([key]) => this.permitAttributes.includes(key))
    )
  }
}
